import { useRef, useCallback } from 'react';

// ==============================|| DRAG TO SCROLL (tables) ||============================== //

export default function useDragScroll() {
  const ref = useRef(null);
  const state = useRef({ active: false, startX: 0, scrollLeft: 0 });

  const isInteractive = (target) =>
    target.closest(
      'button, a, input, select, textarea, label, [role="button"], .MuiCheckbox-root, .MuiSwitch-root, .MuiChip-root'
    );

  const endDrag = useCallback(() => {
    const el = ref.current;
    state.current.active = false;
    if (el) {
      el.style.cursor = 'grab';
      el.style.userSelect = '';
    }
  }, []);

  const onMouseDown = useCallback((e) => {
    const el = ref.current;
    if (!el || e.button !== 0 || isInteractive(e.target)) return;

    state.current = {
      active: true,
      startX: e.pageX,
      scrollLeft: el.scrollLeft
    };
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
  }, []);

  const onMouseMove = useCallback((e) => {
    const el = ref.current;
    if (!state.current.active || !el) return;

    e.preventDefault();
    const delta = e.pageX - state.current.startX;
    el.scrollLeft = state.current.scrollLeft - delta;
  }, []);

  const onTouchStart = useCallback((e) => {
    const el = ref.current;
    if (!el || isInteractive(e.target)) return;
    const touch = e.touches[0];
    state.current = {
      active: true,
      startX: touch.pageX,
      scrollLeft: el.scrollLeft
    };
  }, []);

  const onTouchMove = useCallback((e) => {
    const el = ref.current;
    if (!state.current.active || !el) return;
    const touch = e.touches[0];
    const delta = touch.pageX - state.current.startX;
    el.scrollLeft = state.current.scrollLeft - delta;
  }, []);

  return {
    ref,
    dragHandlers: {
      onMouseDown,
      onMouseMove,
      onMouseUp: endDrag,
      onMouseLeave: endDrag,
      onTouchStart,
      onTouchMove,
      onTouchEnd: endDrag
    }
  };
}
